import React from "react"

import './Footer.css'

const Footer = () => {
    return (
        <footer>
            <div className={`footer-inner`}>
                <p>Agi - Agenzia
    Giornalistica Italia S.p.A.</p>
                <p>Via Ostiense, 72, 00154 Roma<br/>
    Tel. <a href="tel:06519961">06.519961</a>  <a href="mailto:info@agi.it">info@agi.it</a></p>
                <p className={`_service`}>Registrazione del tribunale di Roma: 178/2018 | Editore: Agi  Via Ostiense, 72, 00154 Roma |  Direttore responsabile: Rita Lofano - P.IVA/CF: P.IVA 00893701003</p>
            </div>
        </footer>
    )
}

export default Footer